import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EngineComponent } from './components/engine/engine.component';
import { NgxsModule } from '@ngxs/store';
import { EngineState } from './state/engine.state';
import { StoryModule } from '../story/story.module';
import { EngineCameraState } from './state/camera/engine.camera.state';
import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from '../material.module';
import { EngineCameraBarComponent } from './components/engine-camera-bar/engine-camera-bar.component';
import { EngineToolBarComponent } from './components/engine-tool-bar/engine-tool-bar.component';
import { EngineScrubberComponent } from './components/engine-scrubber/engine-scrubber.component';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { EngineNodesState } from './state/nodes/engine.nodes.state';
import { EngineBreadcrumbComponent } from './components/engine-breadcrumb/engine-breadcrumb.component';

@NgModule({
  imports: [
    NgxsModule.forFeature([
      EngineState,
      EngineCameraState,
      EngineNodesState
    ]),

    CommonModule,
    MaterialModule,
    FormsModule,
    StoryModule,
    SharedModule,
    FontAwesomeModule
  ],
  declarations: [
    EngineComponent,
    EngineCameraBarComponent,
    EngineToolBarComponent,
    EngineScrubberComponent,
    EngineBreadcrumbComponent
  ],
  exports: [
    EngineComponent,
    EngineCameraBarComponent,
    EngineToolBarComponent,
    EngineScrubberComponent,
    EngineBreadcrumbComponent
  ]
})
export class EngineModule { }
